module.exports = __webpack_public_path__ + "media/1.bdaab096.mp4";